import { render, staticRenderFns } from "./RpeTtmAcuteLoadChart.vue?vue&type=template&id=9be74630"
import script from "./RpeTtmAcuteLoadChart.vue?vue&type=script&lang=js"
export * from "./RpeTtmAcuteLoadChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports